import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { getLogger } from "@/infrastructure/di/services";

export const queryClient = new QueryClient({
	queryCache: new QueryCache({
		onError: (error, query) => {
			getLogger().error("[Query Error]", {
				error,
				queryKey: query.queryKey,
			});
		},
	}),
	mutationCache: new MutationCache({
		onError: (error, _variables, _context, mutation) => {
			getLogger().error("[Mutation Error]", {
				error,
				mutationKey: mutation.options.mutationKey,
			});
		},
	}),
	defaultOptions: {
		queries: {
			staleTime: 5 * 60 * 1000, // 5 minutes
			gcTime: 10 * 60 * 1000, // 10 minutes
			retry: (failureCount, error) => {
				// Don't retry on 4xx client errors (except 408 Request Timeout and 429 Too Many Requests)
				if (error && "status" in error) {
					const status = (error as { status: number }).status;
					if (
						status >= 400 &&
						status < 500 &&
						status !== 408 &&
						status !== 429
					) {
						return false;
					}
				}
				return failureCount < 2;
			},
			refetchOnWindowFocus: true,
		},
	},
});
